export const STATUSES_THAT_REMOVE_DO_NOT_FLAG = ['approved'];
export const STATUSES_TO_UPDATE_ON_DO_NOT_FLAG = ['submitted', 'pending'];

export const ADOPTER_STATUS_DO_NOT_ADOPT_VALUES = ['do not adopt'] as const;
